export const capitalize = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const toFullstoryProperty = (str: string): string => {
  return str
    .replace(/[^a-zA-Z0-9]/g, '-')
    .replace(/_+/g, '-')
    .toLowerCase();
};

export const getPlural = (word: string, size: number) => {
  if (size > 1) {
    return `${word}s`;
  } else {
    return word;
  }
};

export const padNumberWithLeadingZeros = (num: number, n = 2) => {
  let s = num.toString();
  while (s.length < n) {
    s = '0' + s;
  }
  return s;
};
